import { render, staticRenderFns } from "./marketPlace.vue?vue&type=template&id=a58396d2&scoped=true"
import script from "./marketPlace.vue?vue&type=script&lang=js"
export * from "./marketPlace.vue?vue&type=script&lang=js"
import style0 from "./marketPlace.vue?vue&type=style&index=0&id=a58396d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58396d2",
  null
  
)

export default component.exports